/**
 * API service for Ping Pong statistics
 */
import { apiCall } from '../../../../services/apiUtil';

export const pingpongStatsAPI = {
  getTournamentStats: async (tournamentId) => {
    return apiCall(`/tournaments/${tournamentId}/stats/pingpong`);
  },

  getPlayerStats: async (playerId, tournamentId = null) => {
    const query = tournamentId ? `?tournamentId=${tournamentId}` : '';
    return apiCall(`/pingpong/players/${playerId}/stats${query}`);
  },

  getMatchHistory: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.tournamentId) params.append('tournamentId', filters.tournamentId);
    if (filters.playerId) params.append('playerId', filters.playerId);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    return apiCall(`/pingpong/matches?${params.toString()}`);
  },

  getHeadToHead: async (playerAId, playerBId) => {
    return apiCall(`/pingpong/head-to-head/${playerAId}/${playerBId}`);
  }
};
